export enum DepositType {
  LIQUIDITY_PROVISION = "LIQUIDITY_PROVISION",
  LOCKER = "LOCKER",
}

export enum walletTypes {
  LOBSTR = "lobstr",
  FREIGHTER = "freighter",
  WALLETCONNECT = "wallet_connect",
}
